import {Link, useHistory} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {Button, Menu} from 'antd';

import {getCurrentUserPermission, Permissions} from '../utils';
import {useDispatch, useSelector} from 'react-redux';
import {doSignOut} from '../redux/actions/user';
export const SiderComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [currentUserPermission, setCurrentUserPermission] =
    useState<Permissions>();
  const isLoggedIn = useSelector((state: any) => state.user.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      getCurrentUserPermission()
        .then(p => {
          setCurrentUserPermission(p);
        })
        .catch(er => {
          console.log('err->', er);
        });
    }
  }, [isLoggedIn]);

  const renderEditorTabs = () => (
    <>
      <Menu.Item key="students">
        <Link to={'/students'}>Students</Link>
      </Menu.Item>
      <Menu.Item key="enrollments">
        <Link to={'/enrollments'}>Enrollments</Link>
      </Menu.Item>

      <Menu.Item key="DiscountCodes">
        <Link to={'/discountcodes'}>Discount Codes</Link>
      </Menu.Item>
    </>
  );
  const renderAdminTabs = () => (
    <>
      <Menu.Item key="tests">
        {/* OLD CODE: <Link to={'/tests'}>Tests</Link> */}
        {/* NEW CODE: Updated to Daily Exercises */}
        <Link to={'/tests'}>Daily Exercises</Link>
      </Menu.Item>
      <Menu.Item key="daily-exercises-review">
        <Link to={'/daily-exercises-review'}>Daily Exercises Review</Link>
      </Menu.Item>
      <Menu.Item key="placement-tests">
        <Link to={'/placement-tests'}>Placement Tests</Link>
      </Menu.Item>
      <Menu.Item key="plans">
        <Link to={'/plans'}>Plans</Link>
      </Menu.Item>

      <Menu.Item key="plan-preview">
        <Link to={'/plan-preview'}>Plan Preview</Link>
      </Menu.Item>

      <Menu.Item key="levels">
        <Link to={'/levels'}>Levels</Link>
      </Menu.Item>

      <Menu.Item key="grades">
        <Link to={'/grades'}>Grades</Link>
      </Menu.Item>

      <Menu.Item key="packages">
        <Link to={'/packages'}>Packages</Link>
      </Menu.Item>
      <Menu.Item key="prices">
        <Link to={'/prices'}>Prices</Link>
      </Menu.Item>
      <Menu.Item key="programs">
        <Link to={'/programs'}>Programs</Link>
      </Menu.Item>

      <Menu.Item key="accounts">
        <Link to={'/accounts/role'}>Accounts</Link>
      </Menu.Item>
      <Menu.Item key="schools">
        <Link to={'/schools'}>Schools</Link>
      </Menu.Item>
      <Menu.Item key="curriculums">
        <Link to={'/curriculums'}>Curriculums</Link>
      </Menu.Item>
      <Menu.Item key="stories">
        <Link to={'/stories'}>Stories</Link>
      </Menu.Item>
    </>
  );

  const renderPartnerTabs = () => (
    <>
      <Menu.Item key="partners">
        <Link to={'/partners'}>Our Partners</Link>
      </Menu.Item>
    </>
  );

  const renderContentCreatorTabs = () => (
    <>
      <Menu.Item key="tests">
        {/* OLD CODE: <Link to={'/tests'}>Tests</Link> */}
        {/* NEW CODE: Updated to Daily Exercises */}
        <Link to={'/tests'}>Daily Exercises</Link>
      </Menu.Item>
      <Menu.Item key="daily-exercises-review">
        <Link to={'/daily-exercises-review'}>Daily Exercises Review</Link>
      </Menu.Item>
    </>
  );

  return (
    <Menu theme="dark" mode="horizontal">
      {(currentUserPermission === 'editor' ||
        currentUserPermission === 'admin') &&
        renderEditorTabs()}
      {currentUserPermission === 'admin' && renderAdminTabs()}
      {currentUserPermission === 'partner' && renderPartnerTabs()}
      {currentUserPermission === 'CONTENT_CREATOR' &&
        renderContentCreatorTabs()}

      <Menu.Item style={{}} key="signOut">
        <Button
          onClick={() => {
            dispatch(doSignOut() as any);
            history.push('/');
          }}>
          Logout
        </Button>
      </Menu.Item>
    </Menu>
  );
};
